import { useStore } from 'vuex';
import getPageSpecificValues from '../utils/GoogleAdTagConstants';
import { useLoadGAMAd } from './useLoadGAMAd';
import { isGAMExperimentEnabled } from '../utils/experimentUtil';

const gamAdsLoaded = [];
let isFacetSelection = false;

const useGoogleAdsManager = {
  initGAMTags({
    page,
    device,
    enableGAMAdsFromApp,
    enableGAMImpressionTags,
    enableGAMClickTags,
    refererURL,
    tagEnv,
    brand = 'mcom',
    productBrand,
    searchKeyword,
    catID,
    topLevelCatID,
    categoryTreeIDs,
    store = useStore(),
  }) {
    const deviceType = device?.toLowerCase() === 'mobile' ? 'mweb' : device;
    const isGoogleTagExperimentEnabled = isGAMExperimentEnabled(brand, page);
    if (enableGAMAdsFromApp && isGoogleTagExperimentEnabled) {
      if (gamAdsLoaded.length > 0) {
        while (gamAdsLoaded.length > 0) gamAdsLoaded.pop();
        isFacetSelection = true;
      }
      const pageElements = page ? Object.keys(getPageSpecificValues(page).ad_data[brand][deviceType]) : [];
      useLoadGAMAd.initGAMScript(
        pageElements,
        page,
        device,
        isFacetSelection,
        enableGAMImpressionTags,
        enableGAMClickTags,
        refererURL,
        tagEnv,
        brand,
        productBrand,
        searchKeyword,
        catID,
        topLevelCatID,
        categoryTreeIDs,
        gamAdsLoaded,
        store,
      );
      if (isFacetSelection) isFacetSelection = false;
    }
  },
};

export default useGoogleAdsManager;
